module.exports = __webpack_public_path__ + "static/media/YF17_2.56a45dfb.jpg";